import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import VuexPersistence from 'vuex-persist';
import RootState from '@/store/rootState';
import user from '@/store/user';
import project from '@/store/project';
import projectList from '@/store/projectList';
import autosave from '@/store/autosave';
import submissions from '@/store/submissions';
import breakpoints from '@/store/breakpoints';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<RootState>({
    key: 'retrolab',
    storage: window.sessionStorage,
    modules: ['project', 'user'],
});

export function createStore(): Store<RootState> {
    return new Vuex.Store({
        modules: { user, project, projectList, autosave, submissions, breakpoints },
        // TODO - for some reason I'm getting vuex errors when uncommenting the next line and running the mock tests, why?
        // strict: process.env.NODE_ENV !== 'production',
        strict: process.env.NODE_ENV === 'development',
        plugins: process.env.NODE_ENV !== 'test' ? [vuexLocal.plugin] : [],
    });
}

const store = createStore();
export default store;

